export default "__VITE_ASSET__$IFM9W04__"